module.exports = __webpack_public_path__ + "img/shaomai.f590f3f0.png";